/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const TEMPLATE_GALLERY_PATH =
  'M3.20833 8.45833L7.29167 7.29167L8.45833 3.20833L4.375 4.375L3.20833 8.45833ZM5.83333 6.70833C5.59028 6.70833 5.38368 6.62326 5.21354 6.45312C5.0434 6.28299 4.95833 6.07639 4.95833 5.83333C4.95833 5.59028 5.0434 5.38368 5.21354 5.21354C5.38368 5.0434 5.59028 4.95833 5.83333 4.95833C6.07639 4.95833 6.28299 5.0434 6.45312 5.21354C6.62326 5.38368 6.70833 5.59028 6.70833 5.83333C6.70833 6.07639 6.62326 6.28299 6.45312 6.45312C6.28299 6.62326 6.07639 6.70833 5.83333 6.70833ZM5.83333 11.6667C5.02639 11.6667 4.26806 11.5135 3.55833 11.2073C2.84861 10.901 2.23125 10.4854 1.70625 9.96042C1.18125 9.43542 0.765625 8.81806 0.459375 8.10833C0.153125 7.39861 0 6.64028 0 5.83333C0 5.02639 0.153125 4.26806 0.459375 3.55833C0.765625 2.84861 1.18125 2.23125 1.70625 1.70625C2.23125 1.18125 2.84861 0.765625 3.55833 0.459375C4.26806 0.153125 5.02639 0 5.83333 0C6.64028 0 7.39861 0.153125 8.10833 0.459375C8.81806 0.765625 9.43542 1.18125 9.96042 1.70625C10.4854 2.23125 10.901 2.84861 11.2073 3.55833C11.5135 4.26806 11.6667 5.02639 11.6667 5.83333C11.6667 6.64028 11.5135 7.39861 11.2073 8.10833C10.901 8.81806 10.4854 9.43542 9.96042 9.96042C9.43542 10.4854 8.81806 10.901 8.10833 11.2073C7.39861 11.5135 6.64028 11.6667 5.83333 11.6667ZM5.83333 10.5C7.12639 10.5 8.22743 10.0455 9.13646 9.13646C10.0455 8.22743 10.5 7.12639 10.5 5.83333C10.5 4.54028 10.0455 3.43924 9.13646 2.53021C8.22743 1.62118 7.12639 1.16667 5.83333 1.16667C4.54028 1.16667 3.43924 1.62118 2.53021 2.53021C1.62118 3.43924 1.16667 4.54028 1.16667 5.83333C1.16667 7.12639 1.62118 8.22743 2.53021 9.13646C3.43924 10.0455 4.54028 10.5 5.83333 10.5Z';

/** Default fill from Figma explore-template-gallery asset. */
export const TEMPLATE_GALLERY_ICON_DEFAULT_FILL = '#202125';

const iconPropTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/** Compass explore / template gallery (12×12). Color via `fill` or CSS `color` + `currentColor`. */
const TemplateGalleryIcon = ({
  size = 12,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path d={TEMPLATE_GALLERY_PATH} fill={fill} />
  </svg>
);

TemplateGalleryIcon.propTypes = iconPropTypes;

export { TemplateGalleryIcon };
export default TemplateGalleryIcon;
